import { useLayoutEffect, useRef, useState } from 'react';

/** Measures SVG text in chart coordinates, including after its web font loads. */
export function useSvgTextWidth(text: string) {
  const ref = useRef<SVGTextElement>(null);
  const [width, setWidth] = useState(0);

  useLayoutEffect(() => {
    const measure = () => {
      const next = ref.current?.getComputedTextLength?.() ?? 0;
      setWidth(Math.ceil(next));
    };
    measure();
    document.fonts?.addEventListener('loadingdone', measure);
    return () => document.fonts?.removeEventListener('loadingdone', measure);
  }, [text]);

  return [ref, width] as const;
}
